var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60826 2.67648H6.42969C6.5279 2.67648 6.60826 2.59612 6.60826 2.49791V2.67648H13.394V2.49791C13.394 2.59612 13.4743 2.67648 13.5725 2.67648H13.394V4.28362H15.0011V2.49791C15.0011 1.70996 14.3605 1.06934 13.5725 1.06934H6.42969C5.64174 1.06934 5.00112 1.70996 5.00112 2.49791V4.28362H6.60826V2.67648ZM17.8583 4.28362H2.14397C1.74888 4.28362 1.42969 4.60282 1.42969 4.99791V5.71219C1.42969 5.81041 1.51004 5.89077 1.60826 5.89077H2.95647L3.50781 17.5649C3.54353 18.326 4.17299 18.9265 4.93415 18.9265H15.0681C15.8315 18.9265 16.4587 18.3283 16.4944 17.5649L17.0458 5.89077H18.394C18.4922 5.89077 18.5725 5.81041 18.5725 5.71219V4.99791C18.5725 4.60282 18.2534 4.28362 17.8583 4.28362ZM14.8962 17.3193H5.10603L4.56585 5.89077H15.4364L14.8962 17.3193Z",
    fill: "#CF1322"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.b72a8d9ce43597f619c31d8365e2178e.svg";
export { ForwardRef as ReactComponent };